import React from 'react';

export function Field({ label, tag, hint, children }) {
  return (
    <div className="flex flex-col gap-1.5 mb-3.5">
      {label ? (
        <label className="text-xs font-bold text-ink-soft flex items-center gap-1.5">
          {label}
          {tag ? (
            <span className="bg-brand-light text-brand-dark text-[10px] font-bold px-1.5 py-0.5 rounded-full">{tag}</span>
          ) : null}
        </label>
      ) : null}
      {children}
      {hint ? <span className="text-[11px] text-ink-faint">{hint}</span> : null}
    </div>
  );
}

const base = 'w-full px-3.5 py-2.5 rounded-xl border-[1.5px] border-brand-light/80 bg-white text-[15px] font-sans text-ink outline-none transition-colors focus:border-brand focus:ring-2 focus:ring-brand/15 placeholder:text-ink-faint';

export function Input({ className = '', ...rest }) {
  return <input className={`${base} ${className}`} {...rest} />;
}

export function Textarea({ className = '', ...rest }) {
  return <textarea className={`${base} resize-none ${className}`} {...rest} />;
}

export function PhoneInput({ value, onChange, autoFocus, onKeyDown, placeholder = '99999 99999' }) {
  return (
    <div className="flex rounded-xl border-[1.5px] border-brand-light/80 overflow-hidden bg-white focus-within:border-brand focus-within:ring-2 focus-within:ring-brand/15">
      <span className="px-3 py-2.5 bg-brand-light/60 text-ink-soft font-extrabold text-[15px] flex items-center">+91</span>
      <input
        className="flex-1 px-3 py-2.5 border-none outline-none text-[15px] font-sans min-w-0"
        placeholder={placeholder}
        type="tel"
        inputMode="numeric"
        maxLength={11}
        value={value}
        onChange={onChange}
        autoFocus={autoFocus}
        onKeyDown={onKeyDown}
      />
    </div>
  );
}
